/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

/**
 * BEM Classname Builder
 */
export class BEM {

	/**
	 * BEM builder constructor
	 *
	 * @param block Block
	 * @param element Element
	 * @param modifiers Modifiers
	 */
	public constructor(
		public block: string,
		public element?: string,
		public modifiers: Array<string> = []
	) {}

	/**
	 * Returns a new BEM builder with changed element name
	 *
	 * @param element Element name
	 * @param preserveModifiers If to preserve modifiers
	 */
	public el(element: string, preserveModifiers: boolean = false) {

		return new BEM(this.block, element, preserveModifiers ? this.modifiers : []);

	}

	/**
	 * Returns a new BEM builder with additional modifiers
	 *
	 * @param modifiers New modifiers
	 * @param mergeModifiers If to merge with current modifiers
	 */
	public mod(modifiers: Array<string>, mergeModifiers: boolean = true) {

		return new BEM(this.block, this.element, mergeModifiers ? this.modifiers.concat(modifiers) : modifiers);

	}

	/**
	 * Returns string representing a className attribute
	 */
	public className() {

		const classes = [];

		classes.push(this.block + ( this.element ? "__" + this.element : "" ));

		for (let i = 0; i < this.modifiers.length; i++) {
			classes.push(this.block + ( this.element ? "__" + this.element : "" ) + "--" + this.modifiers[i]);
		}

		return classes.join(" ");

	}

}
/**
 * Creates a new BEM builder
 *
 * @param block Block
 * @param element Element
 * @param modifiers Modifiers
 */
export function bem(
	block: string,
	element?: string,
	modifiers: Array<string> = []
) {

	return new BEM(block, element, modifiers);

}
